import {
	cn,
	Field,
	FieldDescription,
	FieldLabel,
	InputOTP,
	InputOTPGroup,
	InputOTPSlot,
} from "@monbits/ui";
import * as React from "react";

interface OTPInputProps {
	id?: string;
	label?: string;
	description?: string;
	value: string;
	onChange: (value: string) => void;
	error?: string;
	length?: number;
	disabled?: boolean;
	required?: boolean;
	className?: string;
	onComplete?: (value: string) => void;
}

export const OTPInput: React.FC<OTPInputProps> = ({
	id,
	label,
	description,
	value,
	onChange,
	error,
	length = 6,
	disabled = false,
	required = false,
	className,
	onComplete,
}) => {
	const inputId = React.useId();
	const finalId = id || inputId;

	const handleChange = (newValue: string) => {
		onChange(newValue);

		if (newValue.length === length && onComplete) {
			onComplete(newValue);
		}
	};

	return (
		<Field className={cn("w-full flex flex-col items-center", className)}>
			{label && (
				<FieldLabel htmlFor={finalId} className="text-center mb-2">
					{label}
					{required && <span className="text-destructive ml-0.5">*</span>}
				</FieldLabel>
			)}
			<InputOTP
				maxLength={length}
				id={finalId}
				value={value}
				onChange={handleChange}
				disabled={disabled}
				required={required}
				containerClassName="justify-center"
			>
				<InputOTPGroup className="gap-3 *:data-[slot=input-otp-slot]:h-12 *:data-[slot=input-otp-slot]:w-10 *:data-[slot=input-otp-slot]:text-lg *:data-[slot=input-otp-slot]:rounded-lg *:data-[slot=input-otp-slot]:border-1">
					{Array.from({ length }).map((_, index) => (
						<InputOTPSlot key={`slot-${index}`} index={index} />
					))}
				</InputOTPGroup>
			</InputOTP>
			{error ? (
				<FieldDescription className="text-destructive text-center mt-4">
					{error}
				</FieldDescription>
			) : description ? (
				<FieldDescription className="text-center mt-4">
					{description}
				</FieldDescription>
			) : null}
		</Field>
	);
};
